'use client';
/**
 * The plot-idea chips for the wizard, in the interface language, for the chosen
 * genre (plus the general ones). `null` until loaded or when unavailable — the
 * caller then shows its built-in list. Shuffled once per load so the chips vary.
 */
import { useEffect, useState } from 'react';
import { wizardIdeas } from '../actions/storyIdeas';

export function useWizardIdeas(language: string, genre: string | null | undefined): string[] | null {
  const [ideas, setIdeas] = useState<string[] | null>(null);
  useEffect(() => {
    let alive = true;
    wizardIdeas(language, genre ?? null)
      .then((list) => {
        if (!alive || !list) return;
        const shuffled = [...list];
        for (let i = shuffled.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        setIdeas(shuffled);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [language, genre]);
  return ideas;
}
